module.exports = __webpack_public_path__ + "img/NPC4.png";